import ProjectCategoryModel from 'models/ProjectCategoryModel';
import BudgetAggregate      from 'models/budgetModels/BudgetAggregateModel';

export default class ProjectCategoryBudgetModel extends BudgetAggregate(ProjectCategoryModel) {
	static get path(): string {
		return '/project_categories/_budget';
	}
}
